import React from 'react'

export const TituloModal = ({texto}) => {
  return (
    <div className='tituloaModal'>{texto}</div>
  )
}
